import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

export const FETCH_ADDRESS_CONFIRMATIONS = 'FETCH_ADDRESS_CONFIRMATIONS';
export const REQUEST_ADDRESS_CONFIRMATIONS = 'REQUEST_ADDRESS_CONFIRMATIONS';
export const SUCCESS_ADDRESS_CONFIRMATIONS = 'SUCCESS_ADDRESS_CONFIRMATIONS';
export const FAILURE_ADDRESS_CONFIRMATIONS = 'FAILURE_ADDRESS_CONFIRMATIONS';

export const fetchAddressConfirmations = (pageable?: PageableQueryParams) =>
    action(FETCH_ADDRESS_CONFIRMATIONS, { pageable });
export const requestFetchAddressConfirmations = () => action(REQUEST_ADDRESS_CONFIRMATIONS);
export const requestFetchAddressConfirmationsSuccess = (response: any) =>
    action(SUCCESS_ADDRESS_CONFIRMATIONS, { response });
export const requestFetchAddressConfirmationsFailure = (error: any) => action(FAILURE_ADDRESS_CONFIRMATIONS, { error });
